export const EMPTY_LEVEL = {
  level: 1,
  experience: 0,
  currentLevelExperience: 0,
  nextLevelExperience: 100,
};

export const EMPTY_PROGRESSION = {
  ...EMPTY_LEVEL,
  attack: EMPTY_LEVEL,
  defense: EMPTY_LEVEL,
  intelligence: EMPTY_LEVEL,
  constitution: EMPTY_LEVEL,
};

export const EMPTY_GAINS = {
  experience: 0,
  attackExperience: 0,
  defenseExperience: 0,
  intelligenceExperience: 0,
  constitutionExperience: 0,
};
